<template>
    <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.95312 9.66662L3.95312 8.66662L8 4.61974L12.0469 8.66662L11.0469 9.66662L8 6.61975L4.95312 9.66662Z" fill="currentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGArrowUp"
    }
</script>

<style scoped>

</style>
